import client from './client'

const apiBasePath = '/api/admin/account/service/application/'

export default {
  search: form => client.post(apiBasePath + 'search', form),
  detail: form => client.post(apiBasePath + 'detail', form),
  update: form => client.post(apiBasePath + 'update', form)
}
